<script>
import {Graylog} from '../graylog'

// android_app_version
// ios_app_version

export default {

  props: {
    steps: {
      type: Array
    }
  },

  data() {
    return {
      debug: null
    }
  },

  watch: {
    _steps: {
      immediate: true,
      handler() {
        Graylog.getStats('user', `facility:production AND ${this.steps[0]}`, {
          range: 60*60*24*7
        }).then(response => {
          this.debug = response.data.cardinality
        })
      }
    }
  }

}
</script>

<template>
  <div>
    {{ steps }}

    <hr>

    <pre>
      {{ debug }}
    </pre>

  </div>
</template>

<style>

</style>